<script setup>
    import { defineModel, defineProps, defineEmits } from 'vue';

    // ----------------------------
    // props
    // ----------------------------
    const props = defineProps({
        minute: {
            type: Number,
            required: true,
        },
    });


    // ----------------------------
    // v-Model
    // ----------------------------
    const model = defineModel();    
    // ----------------------------
    // emit
    // ----------------------------
    const emit = defineEmits(['childEmit']);
    // ----------------------------
    // 関数
    // ----------------------------
    // 7:00から22:00まで30分間隔の時間を生成する関数
    function generateTimes() {
        const times = [];
        const startTime = new Date();
        startTime.setHours(7, 0, 0, 0);
        const endTime = new Date();
        endTime.setHours(22, props.minute, 0, 0);

        while (startTime < endTime) {
            times.push(startTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
            startTime.setMinutes(startTime.getMinutes() + 30);
        }
        return times;
    }
    function emitEvent() {
        emit('childEmit');
    }
    const times = generateTimes();
</script>

<template>
    <div class="select">
        <select v-model="model" @change="emitEvent()">
            <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
        </select>
    </div>
</template>

<style></style>
